<template>
  <div class="no-data text-center">
    <img src="../assets/img/ic_bg_car.png">
    <div>
      <p v-if="tips">{{tips}}</p>
      <slot name="noDataFont"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      tips: String,
    },
    data() {
      return {};
    },
    methods: {}
  };
</script>
